export interface SubscriberEditionTotal {
  status: string;
  subscribers: number;
  id?: number;
  statusList?: Array<SubscriberEditionTotal>;
}
